const l = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}), y = (t, n = {
  disableAccountingStyle: !1,
  noEmptyDecimals: !1
}) => {
  var u, i;
  if (t == null)
    return "";
  const c = Number(t), o = l.formatToParts(c), m = ((u = o.find((e) => e.type === "minusSign" && n.disableAccountingStyle)) == null ? void 0 : u.value) || "", s = ((i = o.find((e) => e.type === "currency")) == null ? void 0 : i.value) || "";
  let r = o.filter((e) => !["currency", "minusSign"].includes(e.type)).map((e) => e.value).join("");
  n.noEmptyDecimals && (r = r.replace(/\D00$/, ""));
  const a = !n.disableAccountingStyle && c < 0 ? `(${r})` : r;
  return `${m}${s}${a}`;
}, f = (t, n) => t == null ? "" : `${n ? parseInt(typeof t == "string" ? t : `${Number(t)}`, 10) : Number(t).toFixed(2)}%`;
export {
  y as formatCurrency,
  f as formatPercentage
};
//# sourceMappingURL=utils.js.map
